module.exports = __webpack_public_path__ + "static/img/5.e649ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/5.png
// module id = Z5vr
// module chunks = 0